module.exports = __webpack_public_path__ + "img/Austria.689bf14e.png";